import { render, staticRenderFns } from "./Numberplate.vue?vue&type=template&id=750972ea&"
import script from "./Numberplate.vue?vue&type=script&lang=js&"
export * from "./Numberplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports